import { gql } from "@apollo/client";

export const GET_ORDERS = gql`
  query getOnlinePharmacyOrders($limit: Float, $page: Float) {
    getOnlinePharmacyOrders(limit: $limit, page: $page) {
      ordersUrl
      subscriptionsUrl
      hasMore
      pageNumber
      totalCount
      pageSize
      orders {
        id
        orderNumber
        orderDate
        status
        subtotal
        tax
        trackingNumber
        vetCoveUrl
        items {
          id
          productName
          petId
          petName
          quantity
          price
          imageUrl
          productUrl
        }
      }
    }
  }
`;
